import React, {useContext, useEffect, useMemo, useState} from "react";
import NotifyModal from "./NotifyModal";
import {useQuery} from "react-query";
import {Http, isMessageError} from "@firefly/fly-http";
import AppQueryClientProvider from "../../context/AppQueryClientProvider";
import Cookies from "js-cookie";

export interface AppProps {
    gameId: string
}
function App(props: AppProps) {
    const {
        gameId
    } = props;
    const [open, setOpen] =useState<boolean>(false);
    const userid = Cookies.get('userid');
    const {
        error,
    } = useQuery({
        enabled: !!userid,
        queryKey: ['viewer', userid, 'gamevip', gameId, 'servers'],
        queryFn: () => {
            return Http.get(`/api/wangame/viewer/game-vips/${gameId}/servers`)
        }
    });



    const isNoGameVip = useMemo(() => {
        if (isMessageError(error)) {
            const {
                errorInfo
            } = error;
            return errorInfo.code === 'WANGAME_ERR_NOT_GAME_VIP';
        }
        return undefined;
    }, [error]);
    useEffect(() => {
        if (isNoGameVip === true) {
            setOpen(true)
        }
    }, [isNoGameVip, setOpen]);
    return <div className={"app"}>
        <NotifyModal
            open={open}
            autoClose={{
                timeout: 15
            }}
            close={() => {
                setOpen(false);
            }}
        />
    </div>
}

export default (props: AppProps) => {
    const {
        gameId
    } = props;
    return <AppQueryClientProvider>
        <App gameId={gameId}/>
    </AppQueryClientProvider>
};